<template>
	<div class="content" id="index">
		<div class="header">
			<div class="w1200">
				<div class="header_top flex">
					<router-link to="/" class="header_logo"><img :src="public.bottom_logo" class="block" /></router-link>
					<div class="header_nav f18px">
						<ul>
							<li class="header_nav_list on"><router-link to="/" class="cl_white">首页</router-link></li>
							<li class="header_nav_list"><router-link to="/study" class="cl_white">趣学习</router-link></li>
							<li class="header_nav_list"><router-link to="/career" class="cl_white">生涯规划</router-link></li>
							<li class="header_nav_list"><router-link to="/wish" class="cl_white">志愿填报</router-link></li>
							<li class="header_nav_list"><router-link to="/news_list" class="cl_white">高中资讯</router-link></li>
						</ul>
					</div>
				</div>
				<div class="header_btm flex mat60">
					<div class="header_btm_l">
						<div class="swiper-container banner">
						    <div class="swiper-wrapper">
						        <div class="swiper-slide" v-for="(item,index) in banner" :key="index">
											<router-link :to="item.jump_url"><img :src="item.pic" class="block radius8" /></router-link>
										</div>
						    </div>
						    <div class="swiper-pagination"></div>
						</div>
					</div>
					<div class="header_btm_r radius8 cl_white">
						<div class="header_not" v-if="token === null">
							<div class="login_top tc f20px">欢迎登录趣云课堂</div>
							<div class="login_item mat15">
								<input v-model="name" placeholder="账号/手机号" class="radius20" />
							</div>
							<div class="login_item mat15">
								<input v-model="password" type="password" placeholder="密码" class="radius20" />
							</div>
							<div class="login_tip flex mat15">
								<label for="remember"><input type="checkbox" id="remember" v-model="remember" /><span>记住密码</span></label>
								<router-link to="/forget" class="cl_white">忘记密码？</router-link>
							</div>
							<div class="login_submit mat15">
								<button type="button" class="cl_white radius20 f18px" @click="signIn">登录</button>
							</div>
							<div class="login_wx cur f12px cl_white mat15" @click="wx_login">
								<img src="../../static/icon_wx.png" class="mar5" />
								<span>微信登录</span>
							</div>
							<div class="login_line tc mat10">—————— 没有账号？ ——————</div>
							<router-link :to="{path:'/logon'}" class="login_link block tc cl_white radius20 mat10 f18px">立即注册</router-link>
							<div class="login_btm f12px">
								<router-link to="/help" class="cl_bg"><img src="../../static/icon_problem.png" /><span>会员卡怎么用？</span></router-link>
								<router-link to="/vip_buy" class="cl_bg"><img src="../../static/icon_card.png" /><span>在线购卡</span></router-link>
							</div>
						</div>
						<div class="header_yes" v-else>
							<div class="header_info tc">
								<img :src="myInfo.avatar" class="radius" />
								<p class="f12px">你好，
									<span class="f16px" v-if="[null,''].indexOf(myInfo.real_name) < 0">{{myInfo.real_name}}</span>
									<span class="f16px" v-if="[null,''].indexOf(myInfo.real_name) > 0 && [null,''].indexOf(myInfo.name) < 0">{{myInfo.name}}</span>
									<span class="f16px" v-if="[null,''].indexOf(myInfo.real_name) > 0 && [null,''].indexOf(myInfo.name) > 0">{{myInfo.wx_nickname}}</span>
								</p>
							</div>
							<div class="header_user_cont f12px mat30">
								<router-link to="/personal" class="header_user_list cl_white mab20">
									<div class="header_user_list_top radius">
										<img src="../../static/personal.png" />
									</div>
									<p class="mat15">个人中心</p>
								</router-link>
								<router-link to="/my_task" class="header_user_list cl_white mab20" v-if="myInfo.role == 'student'">
									<div class="header_user_list_top radius">
										<img src="../../static/study.png" />
									</div>
									<p class="mat15">我的作业</p>
								</router-link>
								<!-- <router-link to="" class="header_user_list cl_white mab20" v-if="myInfo.role == 'teacher'">
									<div class="header_user_list_top radius">
										<img src="../../static/study.png" />
									</div>
									<p class="mat15">我的学习中心</p>
								</router-link> -->
								<router-link to="/wrong" class="header_user_list cl_white mab20">
									<div class="header_user_list_top radius">
										<img src="../../static/error.png" />
									</div>
									<p class="mat15">我的错题本</p>
								</router-link>
								<router-link to="/class_manage" class="header_user_list cl_white mab20" v-if="myInfo.role == 'teacher'">
									<div class="header_user_list_top radius">
										<img src="../../static/teacher.png" />
									</div>
									<p class="mat15">回到教师端</p>
								</router-link>
								<router-link to="/add_class" class="header_user_list_btn cl_white" v-if="myInfo.class_id == '0'&&myInfo.role == 'student'">加入班级</router-link>
								<router-link to="/vip_code" class="header_user_list_btn cl_white" v-if="myInfo.level_id == '0'&&myInfo.role == 'student'">激活</router-link>
							</div>
							<button type="button" class="sign_out f18px cl_white" @click="signOut">安全退出</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="hot w1200" v-if="hot.length > 0">
			<div class="hot_header tc">
				<h3 class="f26px bold">热门视频</h3>
				<p class="f18px cl_tip mat5">HOT VIDEO</p>
			</div>
			<div class="hot_cont">
				<ul class="hot_ul">
					<li class="hot_list" v-for="(item,index) in hot" :key="index">
						<router-link :to="{ path: '/video', query: { id: item.id}}" class="block">
							<img :src="item.pic" class="hot_list_img" />
							<div class="hot_list_text">
								<h3 class="f16px mat10"><img src="../../static/icon_time.png" /><span>{{item.add_time}}</span></h3>
								<p class="cl_gray f12px mat10">已观看：{{item.browse_num}}人</p>
							</div>
						</router-link>
					</li>
				</ul>
			</div>
		</div>
		<div class="index_course">
			<div class="w1200">
				<div class="index_selected">
					<course-group @child-event="selectedCheck" :groupInfo="selectedInfo" :groupNav="selectedNav" :groupCont="selectedCont" :groupCurrent="selectedCurrent"></course-group>
				</div>
				<div class="index_subject">
					<course-group2 @child-event="subjectCheck" :groupInfo="subjectInfo" :groupNav="subjectNav" :groupCont="subjectCont" :groupCurrent="subjectCurrent"></course-group2>
				</div>
			</div>
		</div>
		<div class="renew w1200 flex">
			<div class="renew_l">
				<div class="renew_title f20px bold">
					<img src="../../static/video_header.png" />
					<p>最新·课程视频</p>
				</div>
				<div class="renew_l_cont f16px">
					<router-link :to="{ path: '/video', query: { id: item.id}}" v-for="(item,index) in renew_video" :key="index" class="renew_video_list">
						<img :src="item.pic" class="radius8" />
						<p class="clip new_video_title">{{item.name}}</p>
					</router-link>
				</div>
			</div>
			<div class="renew_r">
				<div class="renew_title f20px bold">
					<img src="../../static/icon_test.png" />
					<p>最新·试卷</p>
				</div>
				<div class="renew_test">
					<router-link :to="{ path: '/practice_test', query: { id: item.id }}" v-for="(item,index) in renew_test" :key="index" class="renew_test_list block">
						<div class="renew_test_list_top flex">
							<h3 class="f18px clip">{{item.paperName}}</h3>
							<p class="f16px cl_violet">{{item.number}}题</p>
						</div>
						<div class="renew_test_list_btm cl_gray mat20">
							<p><img src="../../static/icon_time.png" /><span>更新于{{item.year}}</span></p>
							<p><img src="../../static/icon_person.png" /><span>{{item.read_count==null? '0':item.read_count}}</span></p>
						</div>
					</router-link>
				</div>
			</div>
		</div>
		<div class="index_news bg_gray">
			<div class="hot_header tc">
				<h3 class="f26px bold">最新资讯</h3>
				<p class="f18px cl_tip mat5">NEWS INFORMATION</p>
			</div>
			<div class="index_news_cont">
				<div class="w1200">
					<div class="index_news_first flex bg_white radius8">
						<div class="index_news_first_l">
							<img src="../../static/new.png" />
							<router-link :to="{ path: '/news_details', query: { id: news_first.id}}" class="block bold f22px clip mat20">{{news_first.name}}</router-link>
							<h4 class="cl_dark block mat10">{{news_first.remark}}</h4>
							<div class="index_news_first_btm cl_gray f12px mat25">
								<p>发表日期：<span class="cl_black f14px">{{news_first.add_time}}</span></p>
							</div>
						</div>
						<router-link :to="{ path: '/news_details', query: { id: news_first.id}}" class="index_news_first_r"><img :src="news_first.pic" class="index_news_first_img block radius8" /></router-link>
					</div>
					<div class="index_news_div mat20">
						<router-link :to="{ path: '/news_details', query: { id: item.id}}" v-for="(item,index) in index_news" :key="index" class="radius8 bg_white index_news_list">
							<h3 class="f18px clip bold">{{item.name}}</h3>
							<h4 class="cl_dark mat15">{{item.remark}}</h4>
							<div class="index_news_first_btm cl_gray f12px mat15">
								<p>发表日期：<span class="cl_black f14px">{{item.add_time}}</span></p>
							</div>
						</router-link>
					</div>
				</div>
			</div>
		</div>
		<div class="why">
			<div class="why_top">
				<div class="w1200">
					<img src="../../static/link_white.png" />
					<p class="f18px cl_gray">————— 为何选择趣学云课堂？ —————</p>
				</div>
			</div>
			<div class="why_btm">
				<div class="w1200">
					<ul class="why_ul">
						<li class="why_list">
							<img src="../../static/advantage_01.png" classs="why_list_img" />
							<div class="why_list_text">
								<h3 class="cl_dark f18px">网络课堂</h3>
								<p class="cl_gray">随时随地上课</p>
								<p class="cl_gray">价格仅线下课程的1/3</p>
							</div>
						</li>
						<li class="why_list">
							<img src="../../static/advantage_02.png" classs="why_list_img" />
							<div class="why_list_text">
								<h3 class="cl_dark f18px">官方网站</h3>
								<p class="cl_gray">趣学云教育公司旗下</p>
								<p class="cl_gray">官方网络课堂</p>
							</div>
						</li>
						<li class="why_list">
							<img src="../../static/advantage_03.png" classs="why_list_img" />
							<div class="why_list_text">
								<h3 class="cl_dark f18px">雄厚师资</h3>
								<p class="cl_gray">丰富的教师资源</p>
								<p class="cl_gray">目前有超200位各学笠老师</p>
							</div>
						</li>
						<li class="why_list">
							<img src="../../static/advantage_04.png" classs="why_list_img" />
							<div class="why_list_text">
								<h3 class="cl_dark f18px">优质课程</h3>
								<p class="cl_gray">优质课程设计</p>
								<p class="cl_gray">专注高效提分</p>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<vfooter @child-event="parentEvent"></vfooter>
		<!-- 公告 -->
		<el-dialog width="40%" title="公告" center :visible.sync="notice_show"
		 :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
			<div class="tc f20px">{{notice.name}}</div>
			<div class="f16px cl_gray mat20">{{notice.content}}</div>
			<div class="class_dialog_btm tc mat40">
				<button class="f18px cl_white radius20 mal10 class_dialog_confirm" @click="notice_show = false">确定</button>
			</div>
		</el-dialog>
	</div>
</template>


<script>
	import vfooter from '../components/footer.vue'
	import courseGroup from '../components/course_group.vue'
	import courseGroup2 from '../components/course_group.vue'
	// import Swiper from 'swiper'
	import '@/assets/js/swiper.min.js'
	import '@/assets/css/swiper.min.css'
	export default {
		name: 'index',
		components: {
			vfooter,
			courseGroup,
			courseGroup2,
		},
		props: {

		},
		data () {
			return {
				token: localStorage.getItem("token"),//是否登录
				myInfo: {}, //用户信息
				pharse_id: "", //学历
				name: "",//账号
				password: "",//密码
				remember: false,//记住密码
				banner: [], //轮播图
				hot: [], //热门视频
				news_first: {}, //最新资讯
				index_news: [],
				renew_video: [], //最新视频
				renew_test: [], //最新试题
				//精选课程、学科
				selectedCurrent: 0,
				selectedInfo: {
					bg: require("../../static/course_bg_01.png"),
					title: '精选课程',
					titleVice: 'SELECT THE CLASS',
					cont: '名师点拨 不一样的套路,名师点拨 不一样的套路',
				},
				selectedNav: [],
				selectedCont: [],
				subjectCurrent: 0,
				subjectInfo: {
					bg: require("../../static/course_bg_02.png"),
					title: '学科课程',
					titleVice: 'SUBJECT CURRICULUM',
					cont: '因为一个好老师 从此爱上一门课程',
				},
				subjectNav: [],
				subjectCont: [],
				public: {},
				notice_show: false,
				notice: {},
			}
		},
		created() {
			this.getBanner();
		},
		mounted() {
			var that = this;
			if (localStorage.getItem("token")) {
				that.getMyinfo();
			} else {
				that.getHotvideo();
				that.getSelect();
				that.getNewvideo();
				that.getClass();
			}
			if (localStorage.getItem("name")) {
				that.name = localStorage.getItem("name");
				that.password = localStorage.getItem("password");
				that.remember = true;
			}
		},
		destroyed() {
			
		},
		methods: {
			//登录
			signIn () {
				var that = this;
				that.$get("/api/login/login",{
					phone: that.name,
					pwd: that.password
				})
				.then(res => {
					this.$message({
						duration: 1500,
						message: res.msg,
						type: 'success'
					});
					if (that.remember == true) {
						localStorage.setItem("name", that.name);
						localStorage.setItem("password", that.password);
					}
					localStorage.setItem("token", res.data.token);
					setTimeout(() => {
						location.reload();
					}, 1500);
					
				});
			},
			//退出
			signOut () {
				localStorage.removeItem("token");
				location.reload();
			},
			selectedCheck (data) {
				this.selectedCurrent = data;
			},
			subjectCheck (data) {
				this.subjectCurrent = data;
				this.getClasscoures();
			},
			//获取用户信息
			getMyinfo () {
				var that = this;
				that.$get("/api/user/get_user_info",{
					token: localStorage.getItem("token")
				})
				.then(res => {
					that.myInfo = res.data;
					that.pharse_id = that.myInfo.pharse_id;
					that.getHotvideo();
					that.getSelect();
					that.getNewvideo();
					that.getClass();
					if ([0,'',null].indexOf(that.myInfo.class_id) < 0) {
						this.setTime();
					}
				});
			},
			//缓存时间
			setTime () {
				if (localStorage.getItem("time")) {
					let old_time = parseInt(localStorage.getItem("time"));
					let new_time = parseInt(new Date().getTime());
					if (old_time > new_time) {
						
					} else {
						let time = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1;
						localStorage.setItem("time", time);
						this.getNotice();
					}
				} else {
					let time = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1;
					localStorage.setItem("time", time);
					this.getNotice();
				}
			},
			//获取公告
			getNotice () {
				this.$get("/api/index/get_notice",{
					token: localStorage.getItem("token")
				})
				.then(res => {
					this.notice_show = true;
					this.notice = res.data;
				});
			},
			//热门视频
			getHotvideo () {
				var that = this;
				that.$get("/api/course/course_index_hot_data",{
					pharse_id: that.pharse_id,
					limit: 5,
				})
				.then(res => {
					that.hot = res.data;
				});
			},
			//最新视频
			getNewvideo () {
				var that = this;
				that.$get("/api/course/course_index_new_data",{
					pharse_id: that.pharse_id,
					limit: 6,
				})
				.then(res => {
					that.renew_video = res.data;
				});
			},
			//精选课程
			getSelect () {
				var that = this;
				that.$get("/api/Course/course_index_grade_data",{
					pharse_id: that.pharse_id
				})
				.then(res => {
					that.selectedCont = res.data;
				});
			},
			//轮播与资讯
			getBanner () {
				var that = this;
				var news = [];
				that.$get("/api/index/index_data_api",{})
				.then(res => {
					that.banner = res.data.banner;
					that.renew_test = res.data.papers;
					news = res.data.information;
					that.news_first = news[0];
					that.index_news = news.slice(1);
					//轮播图
					var mySwiper = new Swiper('.banner', {
						autoplay: {
							disableOnInteraction: false,
						},
						// loop: true,
						// loopAdditionalSlides : 3,
						pagination: {
							el: '.swiper-pagination',
							clickable :true,
						},
						observer:true,
						observeParents:true,
					});
				});
			},
			//学科分类
			getClass () {
				var that = this;
				that.$get("/api/Course/subject_index_data",{})
				.then(res => {
					that.subjectNav = res.data;
					that.getClasscoures()
				});
			},
			//学科课程
			getClasscoures () {
				var that = this;
				that.$get("/api/Course/course_index_subject_data",{
					pharse_id: that.pharse_id,
					subject_id: that.subjectNav[that.subjectCurrent].subjectId
				})
				.then(res => {
					that.subjectCont = res.data;
				});
			},
			//微信登录
			wx_login () {
				// var url = "http://jy.jiheyun.com/wait_for";
				// var url = "http://test1.joy366.com/wait_for";
				var url = "http://www.joy366.com/wait_for";
				url = encodeURIComponent(url);
				// var appid = "wxc8e7e95bbff8174b";
				var appid = "wx8f41a3d953333118";
				var scope = "snsapi_login";
				var state = "1";
				window.open('https://open.weixin.qq.com/connect/qrconnect?appid=' + appid + '&redirect_uri=' + url + '&response_type=code&scope=' + scope + '&state=' + state, '_blank');
			},
			parentEvent (data) {
				this.public = data;
			},
		},
	}
</script>

<style>
.new_video_title{
	width:235px ;
}
</style>
